import memoizeOne from 'memoize-one'

export const formatNumberToCurrency = memoizeOne(
  (number: number, currency: string): string => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency.toUpperCase(),
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(number / 100)
  },
)
